export var Name = 'add-to-basket-failed';
export var AddToBasketFailedEvent = Name;